import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classe from '../../../../json/classe.json';
import Select from 'react-select';
import { Col, Grid, Row, FormGroup } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { fetchSubstances } from "../../../../redux/actions/substance";
import TrackingService from '../../../../services/TrackingService';

class ClasseForm extends React.Component {
    
    constructor(props) {
        super(props);
        this.props.fetchSubstances();
        this.lastResultStatus = null;
    }

    componentDidUpdate(prevProps) {
        // Track when analysis result changes (indicating a new analysis was performed)
        if (prevProps.result !== this.props.result && this.props.result.status !== null) {
            this.trackAnalysisResult();
        }
    }

    trackAnalysisResult = async () => {
        try {
            const isCI = this.props.result.status === 1;
            const analysisId = await TrackingService.trackAnalysis({
                analysisType: 'CONTRAINDICATION',
                medications: [],
                findingsCount: isCI ? 1 : 0,
                findings: [],
                riskLevel: isCI ? 'HIGH' : 'LOW',
                patientContext: {},
                responseTime: 0,
                cacheHit: false
            });
            if (analysisId) {
                await TrackingService.trackSave(analysisId, {
                    name: 'Analyse de classe pharmacologique',
                    notes: 'Analyse de compatibilité par classe'
                });
                await TrackingService.trackConsultation(analysisId, 5);
            }
        } catch (e) {}
    };

    componentDidMount() {
        if (!this.props.substances || this.props.substances.length === 0) {
            this.props.fetchSubstances();
        }
    }

    stateClasse = {
        classe : null
    }

    stateSubstance = {
        substance : null
    }

    chooseStatus(status){
        switch (status) {
            case null:
                return {bg: "#F5F5F5", col: '#536878' };
            case 0:
                return {bg: "#FFF5FE", col: '#DC143C' };
            case 1:
                return {bg: "#FEFEFA", col: '#FF7E00' };
            case -1:
                return {bg: "#FEFEFA", col: '#03C03C' };
            default:
                return {bg: "#F5F5F5", col: '#536878' };
        }
    }

    render() {
        return (
            <div className="main-content" >
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <Card
                                content=
                                    {
                                        <Grid fluid>
                                            <h3 style={{color:'black', fontSize:'30px'}} className="text-center"><strong>Veuillez renseignez les informations nécessaires pour l&apos;analyse d&apos;interactions médicamenteuses contre-indiquées !</strong></h3>
                                            <Row>
                                                <Col xs={12} sm={6} md={6}>
                                                    <FormGroup>
                                                        <Select
                                                            options={this.props.substances ? this.props.substances.sort((a, b) => {
                                                                return a.name >= b.name ? 1 : -1}).map(substance => ({ label: substance.name, value: substance._id,classesContresIndiquees: substance.classesContresIndiquees })) : []}
                                                            placeholder={this.props.loading ? 'Chargement des substances...' : 'Sélectionner une substance'}
                                                            isLoading={this.props.loading}
                                                            onChange={this.props.onChangeSubstance}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col xs={12} sm={6} md={6}>
                                                    <FormGroup>
                                                        <Select
                                                            options={classe.sort((a, b) => {
                                                                return a.nom_classe >= b.nom_classe ? 1 : -1}).map(classe => ({ label: classe.nom_classe, value: classe.nom_classe }))}
                                                            placeholder={'Classe Pharmacologique'}
                                                            onChange={this.props.onChangeClasse}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Grid>
                                    }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} >
                            <Card
                                content=
                                    {
                                        <div className="text-center"
                                             style={{ height: '100%', backgroundColor: this.chooseStatus(this.props.result.status).bg}}>
                                            <p className="text-center"
                                               style={{paddingTop: '5%', fontSize: '30px', color: this.chooseStatus(this.props.result.status).col}}>
                                                {this.props.result.data}
                                            </p>
                                        </div>
                                    }
                            />
                        </Col>
                    </Row>
                    <div className="text-center">
                        <Button bsStyle='info' fill type="submit" style={{fontSize:"2rem", borderRadius:"20px"}}>
                            Lancer l&apos;analyse
                        </Button>
                    </div>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        substances: state.substances.substances,
        loading: state.status.loading,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetchSubstances: filter => {
            dispatch(fetchSubstances(filter));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ClasseForm);